import React from "react";
import {
  Heart,
  HandHeart,
  DollarSign,
  Users,
  Globe,
  FileText,
  BarChart,
  Calendar,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Donation Platforms",
    description: "Build secure donation systems with multiple payment options",
    icon: DollarSign,
  },
  {
    title: "Crowdfunding Solutions",
    description: "Create fundraising campaigns with social sharing features",
    icon: HandHeart,
  },
  {
    title: "Donor Management",
    description: "CRM systems for donor relationships and communication",
    icon: Users,
  },
  {
    title: "Volunteer Management",
    description: "Platforms for recruiting and coordinating volunteers",
    icon: Heart,
  },
  {
    title: "Impact Reporting",
    description: "Showcase program outcomes and donor impact",
    icon: BarChart,
  },
  {
    title: "Event Fundraising",
    description:
      "Tools for charity events, galas, and peer-to-peer fundraising",
    icon: Calendar,
  },
  {
    title: "Grant Management",
    description: "Track grant applications, compliance, and reporting",
    icon: FileText,
  },
  {
    title: "Global Giving",
    description: "Multi-currency, multi-language giving platforms",
    icon: Globe,
  },
];

const STATS = [
  { value: "$100M+", label: "Funds Raised" },
  { value: "500+", label: "Nonprofits" },
  { value: "2M+", label: "Donors" },
  { value: "Global", label: "Reach" },
];

const CharityIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="charity-funding"
      industryTitle="Charity"
      industrySubtitle="& Funding"
      heroDescription="Empowering nonprofits and charitable organizations with donation platforms, crowdfunding solutions, and donor management systems that maximize impact and engagement."
      themeColor="#db2777"
      themeColorLight="#f472b6"
      themeGradient="linear-gradient(135deg, #831843 0%, #be185d 50%, #db2777 100%)"
      HeroIcon={Heart}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1569908420024-c8f709b75700?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default CharityIndustryPage;
